<template>
  <div>
    <b-notification :has-icon="true" icon="info" :closable="false">
      <p>
        <span v-html="$t('compCarbonFormsPurchasesHelpManual.text-1')" />
      </p>
    </b-notification>
    <help-data />
  </div>
</template>

<script>
export default {
  name: 'HelpManual',
  components: {
    'help-data': () =>
      import('@/components/carbon/forms/purchases/HelpData.vue')
  }
}
</script>
